import { render, staticRenderFns } from "./SalesReceipts.vue?vue&type=template&id=33f767a4&scoped=true"
import script from "./SalesReceipts.vue?vue&type=script&lang=js"
export * from "./SalesReceipts.vue?vue&type=script&lang=js"
import style0 from "./SalesReceipts.vue?vue&type=style&index=0&id=33f767a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f767a4",
  null
  
)

export default component.exports